(function () {
  const GALLERY_SELECTOR = '.f-product-single media-gallery';
  const DOTS_SELECTOR = '.custom-pdp-gallery-dots';
  const MAX_ATTEMPTS = 40;
  const RETRY_MS = 100;
  const boundInstances = new WeakMap();

  function readI18n(gallery) {
    const node = document.getElementById(`custom-pdp-gallery-i18n-${gallery.dataset.sectionId}`);
    if (!node) return { nav: '', dot: '' };

    try {
      return JSON.parse(node.textContent);
    } catch (_error) {
      return { nav: '', dot: '' };
    }
  }

  function labelFor(i18n, index, total) {
    if (!i18n.dot) return String(index + 1);
    return i18n.dot
      .replaceAll('__NUMBER__', String(index + 1))
      .replaceAll('__TOTAL__', String(total));
  }

  function getSliderElement(gallery) {
    return gallery.querySelector('[data-media-viewer] flickity-component.f-product__media-list');
  }

  function getFlickity(gallery) {
    const sliderEl = getSliderElement(gallery);
    if (!sliderEl) return null;
    if (sliderEl.slider && sliderEl.slider.instance) return sliderEl.slider.instance;
    if (window.FoxTheme && window.FoxTheme.Flickity) {
      return window.FoxTheme.Flickity.data(sliderEl) || null;
    }
    return null;
  }

  function getViewer(gallery) {
    return gallery.querySelector('[data-media-viewer]');
  }

  function cellCount(flkty) {
    return (flkty.cells && flkty.cells.length) || 0;
  }

  function selectedIndex(flkty) {
    return typeof flkty.selectedIndex === 'number' ? flkty.selectedIndex : 0;
  }

  function syncDots(nav, flkty) {
    const index = selectedIndex(flkty);
    nav.querySelectorAll('button').forEach(function (button, buttonIndex) {
      if (buttonIndex === index) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  }

  function renderDots(gallery, flkty) {
    const viewer = getViewer(gallery);
    if (!viewer) return;

    const i18n = readI18n(gallery);
    const total = cellCount(flkty);
    let nav = viewer.querySelector(DOTS_SELECTOR);

    if (total < 2) {
      if (nav) nav.remove();
      return;
    }

    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'custom-pdp-gallery-dots';
      viewer.appendChild(nav);
    }

    if (i18n.nav) nav.setAttribute('aria-label', i18n.nav);

    const currentIndex = selectedIndex(flkty);
    nav.replaceChildren();

    for (let index = 0; index < total; index += 1) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'custom-pdp-gallery-dots__dot';
      button.setAttribute('aria-label', labelFor(i18n, index, total));
      if (index === currentIndex) {
        button.setAttribute('aria-current', 'true');
      }
      button.addEventListener('click', function () {
        flkty.select(index);
      });
      nav.appendChild(button);
    }
  }

  function bind(gallery, flkty) {
    const sliderEl = getSliderElement(gallery);
    if (!sliderEl) return;

    if (boundInstances.get(sliderEl) === flkty) {
      renderDots(gallery, flkty);
      return;
    }

    boundInstances.set(sliderEl, flkty);
    renderDots(gallery, flkty);

    flkty.on('change', function () {
      const viewer = getViewer(gallery);
      const nav = viewer && viewer.querySelector(DOTS_SELECTOR);
      if (nav) syncDots(nav, flkty);
    });
    flkty.on('insert', function () {
      renderDots(gallery, flkty);
    });
    flkty.on('remove', function () {
      renderDots(gallery, flkty);
    });
  }

  function enhance(gallery) {
    const flkty = getFlickity(gallery);
    if (!flkty) return false;
    bind(gallery, flkty);
    return true;
  }

  function waitAndEnhance(gallery) {
    if (!gallery || !gallery.matches(GALLERY_SELECTOR)) return;
    if (enhance(gallery)) return;

    let attempts = 0;
    const timer = setInterval(function () {
      attempts += 1;
      if (enhance(gallery) || attempts >= MAX_ATTEMPTS) {
        clearInterval(timer);
      }
    }, RETRY_MS);
  }

  function enhanceAll() {
    document.querySelectorAll(GALLERY_SELECTOR).forEach(waitAndEnhance);
  }

  function galleryFromEvent(target) {
    if (!target) return null;
    if (target.matches && target.matches(GALLERY_SELECTOR)) return target;
    if (target.closest) return target.closest(GALLERY_SELECTOR);
    return null;
  }

  document.addEventListener('product-media:loaded', function (event) {
    const gallery = galleryFromEvent(event.target);
    if (gallery) waitAndEnhance(gallery);
  });

  document.addEventListener('matchMobile', enhanceAll);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    const gallery = event.target.querySelector(GALLERY_SELECTOR);
    if (gallery) waitAndEnhance(gallery);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
})();
